<template>
	<div>
		<notifications />
        <preloader v-if="isLoading"></preloader>
		<template-form
            v-if="!isLoading"
			title="Edit Recurring Invoice"
			submitTxt="Update Recurring Invoice"
			defaultFormType="edit"
			:fields="fields"
			:errors="fieldErrors"
			:masterService="masterService"
			:masterCustomer="masterCustomer"
			:defaultPaymentTerm="defaultPaymentTerm"
			:totalPercent="totalPercent"
			:createMilestone="createMilestone"
			:removeMilestone="removeMilestone"
			:isLoading="isLoading"
			:onSubmit="handleSubmit"
			:basePrice="basePrice" />
	</div>
</template>

<script>
import Form from './Form.vue';
import { defaultFields, getBasePrice, defaultErrors } from "./helpers";
import { defaultListFields } from "../customers/helpers";
import { displayDate } from "../../helpers";
import { RecurringInvoice } from '../../repositories';
import Preloader from "../Preloader.vue";

export default {
	components: {
		'template-form': Form, Preloader
	},
	data() {
		return {
			isLoading: false,
			fields: defaultFields(),
			fieldErrors: defaultErrors(),
			defaultPaymentTerm: [],
			basePrice: 0,
			masterService: [],
			masterCustomer: defaultListFields()
		}
	},
	computed: {
		totalPercent() {
			let items = this.defaultPaymentTerm;
			let currentPercentage = items.reduce((subtotal, item) => {
				return parseFloat(subtotal) + parseFloat(item.percentage);
			}, 0);
			return currentPercentage - 100;
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			// const response = await axios.get(`/services/${this.$route.params.id}`);
			// this.fields = this.parseData(response.data.data);
			// this.basePrice = await getBasePrice();
			const proposalResponse = await axios.get(`/recurring-invoices/` + this.$route.params.id);
			// const proposalResponse = await RecurringInvoice.showAsync();
			this.fields = this.parseData(proposalResponse.data.data);
			
			const response = await axios.get('/services');
			this.masterService = response.data.data;

			const customerResponse = await axios.get('/customers');
			this.masterCustomer = customerResponse.data.data.map((obj) => {return {label: obj.name, ...obj}; });

			const settingResponse = await axios.get('settings');
			this.defaultPaymentTerm = JSON.parse(this.fields.payment_terms);
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}

		this.isLoading = false;
	},
	methods: {
		async handleSubmit(fields) {
			this.fieldErrors = defaultErrors();
			this.isLoading = true;

			if (!this.validateInputs()) {
				this.isLoading = false;
				return;
			}

			try {
				var data = {
					...fields,
					customer_id: fields.customer.id,
					payment_terms: JSON.stringify(this.defaultPaymentTerm),
				}
				const response = await axios.patch(`/recurring-invoices/${this.$route.params.id}`, data);
				this.$notify({
					type: 'success',
					title: 'Invoice Updated',
					text: 'You\'ve successfully updated the invoice!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		parseData(item) {
			return {
				id: item.id,
				title: item.title,
				customer: {
					...item.customer,
					label: item.customer.name,
				},
				title: item.title,
				frequency: item.frequency,
				created_at: displayDate(item.created_at),
				start_date: displayDate(item.start_date),
				end_date: displayDate(item.end_date),
				discount: item.discount,
				items: item.details,
				payment_terms: item.payment_terms,
				terms: item.terms,
				type: item.type,
				note: item.note
			}
		},
		updateSubservices(newList) {
			this.fields.subservices = newList;
		},
		createMilestone() {
			this.defaultPaymentTerm.push({description: null, percentage: 0});
		},
		removeMilestone(targetIndex) {
			let items = this.defaultPaymentTerm;
			this.defaultPaymentTerm = items.filter((item, index) => {
				return index != targetIndex;
			});
		},
		validateInputs() {
			if (this.totalPercent != 0) {
				this.fieldErrors.payment_term = 'Invalid total payment percentage.';
				return false;
			}

			return true;
		},
	}
}
</script>
